<div class="counter col-3 col-sm-3 col-md-2 col-lg-1 p-0">
   <p class="d-flex m-0">
    {{count}} visitors online
   </p>
</div>
